// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "component---src-pages-index-tsx" + "-" + "8cbd66be318f397703e3" + ".js";
};